<template>
  <button type="button" class="boton-accion" @click="$emit('click', $event)">
    <span
      v-if="contador !== null && contador !== undefined"
      class="badge"
      :style="{ background: colorBadge }"
    >
      {{ contador }}
    </span>
    <i :class="icono" class="icono"></i>
    <span class="texto">{{ texto }}</span>
  </button>
</template>

<script>
export default {
  name: 'BotonAccionGuardias',
  props: {
    icono: { type: String, required: true },
    texto: { type: String, required: true },
    contador: { type: [Number, String], default: null },
    colorBadge: { type: String, default: '#26c6da' }
  },
  emits: ['click']
}
</script>

<style scoped>
.boton-accion {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 80px;
  padding: 10px 12px;
  background: #f0f0f0;
  border: 1px solid #d5d5d5;
  border-radius: 3px;
  color: #555;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s;
}
.boton-accion:hover {
  background: #e6e6e6;
}
.icono {
  font-size: 1.3rem;
  color: #666;
}
.badge {
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}
</style>